import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LogHelper } from 'app/core/helpers/log.helper';
import { AssignAndMoveWalletRequest, AvailableWalletsResponse } from 'app/core/models/patient.model';
import { PatientService } from 'app/core/services/patient.service';
import { AlertService } from 'app/shared/alert/alert.service';
import { ModalComponent } from 'app/shared/modal/modal.component';

@Component({
  selector: 'app-confirm-wallet-assignment-modal',
  templateUrl: './confirm-wallet-assignment-modal.component.html',
  styleUrls: ['./confirm-wallet-assignment-modal.component.scss']
})
export class ConfirmWalletAssignmentModalComponent {
  @ViewChild("modal") modal: ModalComponent;

  @Input() paymentInfoForm: FormGroup;
  @Input() patientId: string;
  @Input() availableWalletsList: AvailableWalletsResponse[];

  @Output('onConfirmWalletAssignmentResult') onConfirmWalletAssignmentResult = new EventEmitter<boolean>();

  selectedWallet: string;
  isAssignmentProcessing: boolean = false;
  moveAndAssignButtonText: string = "Continue";
  moveAndAssignFailure: boolean = false;

  constructor(
    private patientService: PatientService,
    private alertService: AlertService
  ) { }

  onConfirmWalletAssignment() {
    this.isAssignmentProcessing = true;
    let wallet = this.availableWalletsList.find(w => w.walletId == this.selectedWallet);

    let request: AssignAndMoveWalletRequest = {
      patientTrialId: this.patientId,
      walletId: wallet.walletId,
      walletName: wallet.walletName,
      walletAccountHolder: wallet.walletAccountHolder,
      walletIsOnChildSubsidiary: wallet.walletIsOnChildSubsidiary
    };

    this.patientService.assignAndMoveWallet(request).subscribe({
      next: (result) => {
        this.paymentInfoForm.get("caxtonWalletName").setValue(result.walletName);
        this.paymentInfoForm.get("caxtonWalletId").setValue(result.walletId);
        this.paymentInfoForm.get("caxtonWalletName").disable();
        this.paymentInfoForm.markAsDirty();

        this.modal.hide();

        if (result.cardAlreadyActive) {
          this.alertService.showSuccessAlert(`Card on ${request.walletName} was already active.`);
        } else {
          this.alertService.showSuccessAlert(`You have successfully assigned and moved ${result.walletName}`);
        }

        this.isAssignmentProcessing = false;

        this.onConfirmWalletAssignmentResult.emit(result.cardAlreadyActive);
      },
      error: (error) => {
        this.moveAndAssignFailure = true;
        this.moveAndAssignButtonText = "Please refresh the page";
        this.isAssignmentProcessing = false;
        this.alertService.showWarningAlert(error.error ? error.error.title : 'Failed to assign and move wallet. Please try again or contact support.');
        LogHelper.log(error);
      },
    });
  }
}
